import { createSelector } from 'reselect';

export const selectEventMaterialsSlice = state => state.eventMaterials;

export const selectEventMaterials = createSelector(
  selectEventMaterialsSlice,
  slice => slice.eventMaterials
);
export const eventMaterialsLoaded = createSelector(
  selectEventMaterialsSlice,
  slice => slice.eventMaterialsLoaded
);
export const selectActiveEventMaterial = createSelector(
  selectEventMaterialsSlice,
  slice => slice.activeEventMaterial
);

export const eventMaterialsMeta = createSelector(
  selectEventMaterialsSlice,
  slice => slice.meta
);
export const eventMaterialsFilters = createSelector(
  selectEventMaterialsSlice,
  slice => slice.filters
);
export const eventMaterialsEvent = createSelector(
  selectEventMaterialsSlice,
  slice => slice.eventId
);

export const eventMaterialCreating = createSelector(
  selectEventMaterialsSlice,
  slice => slice.isCreating
);
export const eventMaterialsUpdating = createSelector(
  selectEventMaterialsSlice,
  slice => slice.isUpdating
);
export const eventMaterialsDeleting = createSelector(
  selectEventMaterialsSlice,
  slice => slice.isDeleting
);
export const eventMaterialsErrors = createSelector(
  selectEventMaterialsSlice,
  slice => slice.errors
);
